// extracted by mini-css-extract-plugin
export default {"color-filter":"NaiDQDT0eZbdAidfEHdm","colorFilter":"NaiDQDT0eZbdAidfEHdm"};